<script setup lang="ts">
import { Icon } from '@iconify/vue'

defineProps<{ title: string; items: { label: string; value: string }[]; loading?: boolean }>()
</script>

<template>
  <el-card v-loading="loading">
    <div class="flex flex-col gap-6">
      <h4>{{ title }}</h4>
      <div class="flex flex-col gap-4">
        <div v-for="item in items" :key="item.label" class="inline-flex gap-1">
          <p class="flex-1 text-tertiary">{{ item.label }}</p>
          <Icon v-if="loading" icon="eos-icons:three-dots-loading" height="16" />
          <p v-else class="flex-1">{{ item.value ?? '&#8211;' }}</p>
        </div>
      </div>
    </div>
  </el-card>
</template>
